import { Avatar } from "primereact/avatar";
import React from "react";
import ReactCountryFlag from "react-country-flag";
import CustomeButton from "~/components/Button";
import { getName } from "country-list";

const DuplicateInformationCard = ({ duplicate, onAddAsDuplicate, type }) => {
  const getInitials = (fullName) => {
    const nameArray = fullName?.split(" ");
    const firstInitial = nameArray[0]?.charAt(0) || "";
    const lastInitial =
      nameArray.length > 1 ? nameArray[nameArray.length - 1].charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
  };

  const getButtonLabel = () => {
    if (type === "shareholder") return "Add as Shareholder";
    if (type === "director") return "Add as Director";
    return "Add";
  };

  const getTypeLabel = () => {
    if (duplicate?.type)
      return `${duplicate.type} ${type === "shareholder" ? "Shareholder" : "Director"}`;
  };

  return (
    <div className="duplicate__information__card">
      <div className="flex align-items-center mb-3">
        <Avatar
          className="avatar"
          shape="circle"
          label={getInitials(duplicate?.full_name)}
        />
        <div className="card__detail">
          <p className="card-name">{duplicate?.full_name}</p>
          <p className="desc">{getTypeLabel()}</p>
          <p className="desc">
            <ReactCountryFlag
              countryCode={duplicate?.addressData?.country}
              svg
              className=""
            />{" "}
            {getName(duplicate?.addressData?.country || "")}
          </p>
          <p className="desc">
            Linked to {duplicate?.linked_entities_count || 0} more{" "}
            {duplicate?.linked_entities_count > 1 ? "entities" : "entity"}.
          </p>
        </div>
      </div>
      <div className="flex">
        {!duplicate?.is_linked_to_entity ? (
          <CustomeButton
            type="button"
            className="flex-1"
            label={getButtonLabel()}
            variant="contained"
            loading={false}
            onClick={() => onAddAsDuplicate(duplicate)}
            disabled={false}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default DuplicateInformationCard;
